import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type CashInProps = {
  index: number
}

export const CashIn = ({ index }: CashInProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.cashIn`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Cash In" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
